import {
  FaInstagram,
  FaFacebook,
  FaTwitter,
  FaLinkedin,
  FaPinterest,
  FaTiktok,
  FaWordpress,
  FaShopify,
  FaStripe,
  FaPaypal,
  FaSlack,
  FaAmazon,
  FaGoogle,
} from "react-icons/fa";
import { FiDatabase } from "react-icons/fi"; // fallback

export const connectionIcons = {
  // SOCIAL MEDIA
  Instagram: FaInstagram,
  Facebook: FaFacebook,
  "Twitter (X)": FaTwitter,
  "LinkedIn Company Page": FaLinkedin,
  Pinterest: FaPinterest,
  TikTok: FaTiktok,

  // ECOMMERCE
  WooCommerce: FiDatabase, // no FA logo, fallback
  Shopify: FaShopify,
  Magento: FiDatabase, // fallback

  // CMS / WEBSITE
  WordPress: FaWordpress,
  Drupal: FiDatabase,
  Contentful: FiDatabase,
  RebelMonkey: FiDatabase,

  // HOSTING
  AWS: FaAmazon,
  Azure: FiDatabase,
  "Google Cloud": FaGoogle,

  // FINANCE / OPERATIONS
  Stripe: FaStripe,
  PayPal: FaPaypal,
  Xero: FiDatabase,
  QuickBooks: FiDatabase,

  // MARKETING / ADS
  "Google Ads": FaGoogle,
  "Facebook Ads": FaFacebook,
  "LinkedIn Ads": FaLinkedin,
  "TikTok Ads": FaTiktok,

  // EMAIL / CRM
  Mailchimp: FiDatabase,
  HubSpot: FiDatabase,

  // PRODUCTS / INVENTORY
  "Zoho Inventory": FiDatabase,
  "Shopify Products": FaShopify,

  // OPERATIONS / LOGISTICS
  ShipStation: FiDatabase,
  Slack: FaSlack,

  // DOMAIN MANAGEMENT
  GoDaddy: FiDatabase,
  Namecheap: FiDatabase,
  Cloudflare: FiDatabase,
  "Google Domains": FaGoogle,
  "SSL Certificates": FiDatabase,
};
